<template>
  <NewHomeSection2></NewHomeSection2>
  <NewOurServices></NewOurServices>
  <NewOurProjects></NewOurProjects>
  <NewOurClients></NewOurClients>
  <NewContactUs></NewContactUs>
  <NewFooterDetails></NewFooterDetails>
</template>

<script>
import NewHomeSection2 from "./NewHomeSectionfile.vue";
import NewOurServices from "./NewOurServicesfile.vue";
import NewOurProjects from "./NewOurProjectsfile.vue";
import NewContactUs from "./NewContactUs.vue";
import NewOurClients from "./NewOurClients.vue";
import NewFooterDetails from "./NewFooterDetails.vue";
export default {
  components: {
    NewHomeSection2,
    NewOurServices,
    NewOurProjects,
    NewContactUs,
    NewOurClients,
    NewFooterDetails
  },
};
</script>
